import { AtSign, Instagram, Youtube } from 'lucide-react';
import type { AccountPlatform } from '../model/types';

export function TikTokIcon({ className }: { className?: string }) {
  // У lucide нет значка TikTok — нота.
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M16.5 3c.3 2 1.6 3.6 3.5 3.9v2.5c-1.3.1-2.5-.3-3.6-1v6.1a5.5 5.5 0 1 1-5.5-5.5c.3 0 .6 0 .9.1v2.6a2.9 2.9 0 1 0 2 2.8V3h2.7z" />
    </svg>
  );
}

/** Значок сети: у Threads своего в lucide нет — «@», как на кнопках входа. */
export function PlatformIcon({ platform, className }: { platform?: AccountPlatform; className?: string }) {
  if (platform === 'tiktok') return <TikTokIcon className={className} />;
  if (platform === 'youtube') return <Youtube className={className} />;
  if (platform === 'threads') return <AtSign className={className} />;
  return <Instagram className={className} />;
}
